// @story HIR-TC2
// The candidate's EARLIER rounds on a later panel's marking page: each
// round's mark (each panellist's and the average) and its remarks, as the
// group decided (Aarti Pathak, 23 Sep 2026). If the school chose "remarks
// first", the API leaves earlier marks out until you have submitted your own
// here; this screen only shows what it is given. Within this round nothing
// changes: fellow panellists' marks appear only after you submit yours.
import React from "react";
import { StatusPill } from "../ds";
import { Section } from "../components/page";

const muted = { color: "var(--text-muted)", fontSize: "var(--fs-caption)" };
const soft = { background: "var(--surface-2)", borderRadius: "var(--radius-sm)", padding: "8px 10px" };

export default function EarlierRounds({ data }) {
  const rounds = data?.rounds || [];
  if (!rounds.length) return null;
  return (
    <Section
      title="Earlier rounds"
      subtitle={data.marksShown ? "Marks and remarks from the rounds before this one" : "Remarks from earlier rounds. Their marks show once you have submitted yours."}
    >
      <div style={{ display: "grid", gap: 12 }}>
        {rounds.map((r) => (
          <div key={r.stageId} style={{ display: "grid", gap: 4 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
              <span style={{ fontWeight: 500, color: "var(--text-1)", fontSize: "var(--fs-body-sm)" }}>{r.label}</span>
              {r.noMarks && <StatusPill tone="neutral">No marks</StatusPill>}
              {r.referenceOnly && <StatusPill tone="neutral">Reference only</StatusPill>}
              {typeof r.mark === "number" && <span className="num" style={{ fontWeight: 600, color: "var(--text-1)" }}>{r.mark}%</span>}
              {r.marksWithheld && <span style={muted}>Mark shown after you submit</span>}
              {!r.noMarks && r.mark === null && !r.marksWithheld && <span style={muted}>No mark</span>}
            </div>
            {r.marks?.length > 1 && (
              <div style={muted}>{r.marks.map((m) => `${m.by || "Panellist"} ${m.score}%`).join(" · ")}</div>
            )}
            {r.remarks?.map((x, i) => (
              <div key={i} style={{ ...soft, fontSize: "var(--fs-body-sm)", color: "var(--text-1)" }}>
                {x.text}{x.by ? <span style={muted}> — {x.by}</span> : null}
              </div>
            ))}
          </div>
        ))}
      </div>
    </Section>
  );
}
